import { render, staticRenderFns } from "./agreementForeign.vue?vue&type=template&id=c44aae16&scoped=true&"
import script from "./agreementForeign.vue?vue&type=script&lang=js&"
export * from "./agreementForeign.vue?vue&type=script&lang=js&"
import style0 from "./agreementForeign.vue?vue&type=style&index=0&id=c44aae16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44aae16",
  null
  
)

export default component.exports